import script from "./PorqueReservar2.vue?vue&type=script&setup=true&lang=js"
export * from "./PorqueReservar2.vue?vue&type=script&setup=true&lang=js"

import "./PorqueReservar2.vue?vue&type=style&index=0&id=4730f640&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4730f640"]])

export default __exports__